import { IconButton, Stack, Typography, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import React from "react";

export default function CountNum({
  count,
  handleCountNumber,
  maxOrder,
  qty,
  call,
}) {
  const theme = useTheme();

  return (
    <Stack sx={{ position: "relative", gap: 0.5 }}>
      <Typography
        variant="body1"
        sx={{
          fontSize: "0.95rem",
          fontWeight: "bold",
          color: theme.palette.text.primary,
        }}
      >
        تعداد :
      </Typography>

      <Stack
        direction={"row"}
        sx={{
          borderRadius: "14px",
          maxWidth: "160px",
          justifyContent: "space-between",
          alignItems: "center",
          p: "4px",
          backgroundColor: "rgba(255, 255, 255, 0.02)",
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255, 255, 255, 0.06)",
          boxShadow: "inset 0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <IconButton
          onClick={() => handleCountNumber("plus")}
          sx={{
            transition: "all .2s ease",
            borderRadius: "10px",
            color: theme.palette.primary.main,
            backgroundColor: "rgba(255,255,255,0.02)",
            p: "6px",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.05)",
              transform: "scale(1.05)",
            },
            "&:disabled": { opacity: 0.3 },
          }}
          disabled={count >= maxOrder || count >= qty || call}
        >
          <AddIcon sx={{ fontSize: "1.1rem" }} />
        </IconButton>

        <Typography
          sx={{
            fontWeight: 800,
            fontSize: "1.05rem",
            width: "30px",
            textAlign: "center",
          }}
        >
          {count}
        </Typography>

        <IconButton
          onClick={() => handleCountNumber("mines")}
          sx={{
            transition: "all .2s ease",
            borderRadius: "10px",
            color: theme.palette.primary.main,
            backgroundColor: "rgba(255,255,255,0.02)",
            p: "6px",
            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.05)",
              transform: "scale(1.05)",
            },
            "&:disabled": { opacity: 0.3 },
          }}
          disabled={count <= 0 || call}
        >
          <RemoveIcon sx={{ fontSize: "1.1rem" }} />
        </IconButton>
      </Stack>
    </Stack>
  );
}
